import React from "react";
import { Button, Card, Empty, List, Space, Typography } from "antd";

const { Text } = Typography;

const NotificationDesktop = ({ viewModel }) => {
  const {
    items,
    loading,
    submitting,
    isInboxOnly,
    unreadCount,
    onReadAll,
    onItemClick,
    goSettings,
    formatTime,
  } = viewModel;

  return (
    <Card
      title={
        <Space size={4}>
          <Text strong>Thông báo</Text>
          <Button
            type="link"
            onClick={onReadAll}
            loading={submitting}
            disabled={unreadCount === 0}
            style={{ paddingInline: 4 }}
          >
            Đánh dấu đã đọc hết
          </Button>
        </Space>
      }
      extra={
        <Space>
          {!isInboxOnly ? <Button onClick={goSettings}>Cấu hình nhận thông báo</Button> : null}
        </Space>
      }
    >
      <List
        loading={loading}
        dataSource={items}
        locale={{
          emptyText: <Empty description="Chưa có thông báo" image={Empty.PRESENTED_IMAGE_SIMPLE} />,
        }}
        renderItem={(item) => (
          <List.Item
            onClick={() => onItemClick(item)}
            style={{
              cursor: "pointer",
              alignItems: "flex-start",
              marginBottom: 8,
              padding: 12,
              borderRadius: 8,
              border: `1px solid ${item?.read_on ? "#f0f0f0" : "#91caff"}`,
              background: item?.read_on ? "#fff" : "#f6ffed",
            }}
          >
            <Space direction="vertical" size={2} style={{ width: "100%" }}>
              <Text strong>{item.title}</Text>
              <Text>{item.message}</Text>
              <Text type="secondary" style={{ fontSize: 12 }}>
                {formatTime(item.create_on)}
              </Text>
            </Space>
          </List.Item>
        )}
      />
    </Card>
  );
};

export default React.memo(NotificationDesktop);
